function moveTeamSidebar() {
  const sidebar = document.querySelector(".team-sidebar");
  const header = document.querySelector(".team-header");
  const bio = document.querySelector(".team-bio");

  if (!sidebar || !header || !bio) return;

  const windowWidth = window.innerWidth;
  const breakpoint = 930;

  if (windowWidth <= breakpoint) {
    // Move sidebar content between header and bio
    if (sidebar.parentNode.classList.contains("container")) {
      // Only move if it's still in the original position
      header.insertAdjacentElement("afterend", sidebar);
    }
  } else {
    // Move sidebar back to original position (after .team-main)
    const teamMain = document.querySelector(".team-main");
    const container = document.querySelector(".team-single .container");

    if (
      teamMain &&
      container &&
      !sidebar.parentNode.classList.contains("container")
    ) {
      // Only move if it's not in the original position
      container.appendChild(sidebar);
    }
  }
}

if (document.body.classList.contains("single-team")) {
  // Run on page load
  document.addEventListener("DOMContentLoaded", moveTeamSidebar);

  // Run on window resize
  window.addEventListener("resize", moveTeamSidebar);
}
